export enum ClientStatusEnum {
  Active = 'Ativo',
  Blocked = 'Bloqueado',
  ConversionFailed = 'Falha na conversão',
  Converted = 'Convertido',
  Inactive = 'Inativo',
}
